import { render, staticRenderFns } from "./TeacherInfo.vue?vue&type=template&id=fbdb3d78&"
import script from "./TeacherInfo.vue?vue&type=script&lang=js&"
export * from "./TeacherInfo.vue?vue&type=script&lang=js&"
import style0 from "./TeacherInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports